//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "RPI",
  data() {
    return {
      form: {
        ret: "",
        hct:'',
      },
      time:'',
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  watch:{
    'form.hct':{
      handler(val) {
       if(val < 15) {
       this.time = 3
       }else if( val>= 15 && val <=23) {
       this.time = 2.5
       }else if( val>= 24 && val <=33) {
       this.time = 2
       }else if( val>= 34 && val <=38) {
       this.time = 1.5
       }else if( val>= 39) {
       this.time = 1
       }
      }
     
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "...";
      } else {
        let result = (form.ret * (form.hct / 45) / self.time).toFixed(1)
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/RPI.vue